import type { SVGProps } from 'react';

type ArrowLeftIconProps = {
    width?: number | string;
    height?: number | string;
    color?: string;
    className?: string;
    svgProps?: SVGProps<SVGSVGElement>;
};

const ShopArrowLeftIcon = ({ width = 16, height = 26, color = 'currentColor', className = '', svgProps }: ArrowLeftIconProps) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 16 26" fill="none" className={className} {...svgProps}>
            <path d="M12.09 26L15.1883 23.2122L5.61889 13.3972L15.1883 2.80222L12.09 0L0 13.3828L12.09 26Z" fill={color} />
        </svg>
    );
};

export default ShopArrowLeftIcon;
